import { GroupeIndividu } from './GroupeIndividu';
import { MobiDocument } from './MobiDocument';

export class GroupeActivite extends MobiDocument{
    private _id : string;
    private _rev : string;
    private id : number;
    private activite_id : number;
    private groupe_id : number;
    private age_min : number;
    private age_max : number;
    private capacite : number;


    public constructor( groupeactivite : any){
        super()
        this._id = groupeactivite._id;
        this._rev = groupeactivite._rev;
        this.id = groupeactivite.id;
        this.activite_id = groupeactivite.activite_id;
        this.groupe_id = groupeactivite.groupe_id;
        this.age_min = groupeactivite.age_min;
        this.age_max = groupeactivite.age_max;
        this.capacite = groupeactivite.capacite;
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getActivite_id(): number {
        return this.activite_id;
    }

    public setActivite_id(activite_id: number): void {
        this.activite_id = activite_id;
    }

    public getGroupe_id(): number {
        return this.groupe_id;
    }

    public setGroupe_id(groupe_id: number): void {
        this.groupe_id = groupe_id;
    }

    public getAge_min(): number {
        return this.age_min;
    }

    public setAge_min(age_min: number): void {
        this.age_min = age_min;
    }

    public getAge_max(): number {
        return this.age_max;
    }

    public setAge_max(age_max: number): void {
        this.age_max = age_max;
    }

    public getCapacite(): number {
        return this.capacite;
    }

    public setCapacite(capacite: number): void {
        this.capacite = capacite;
    }

    public getGroupeIndividu(): GroupeIndividu{
        return this.memdb.findOne({
            doctype: "GroupeIndividuDocument",
            fkey: "id",
            fvalue: this.groupe_id

        }) as GroupeIndividu;
    }
}